/* eslint-disable max-len */
import React from 'react';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';

// import Eye from '../icons/Eye'; (ENGA-1367)
import IntroSection from '../../common/IntroSection';
// import SharePreviewPopover from '../../common/SharePreviewPopover'; (ENGA-1367)
import PressReleaseWrittenContentV2 from '../components/PressReleaseWrittenContentV2';
import SubHeader from '../../../common/SubHeader';
import { checkoutURL } from '../helpers/divewireConstants';
import PRESS_RELEASE_STATUS from '../helpers/pressReleaseUtils';

const ReviewScreen = () => {
  const { pressRelease, pressReleaseMetadata } = useOutletContext();
  const navigate = useNavigate();
  const { token } = useParams();

  const handlePromoteClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    navigate(`${checkoutURL}/${token}/promote`);
  };
  const handleBackNavigation = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    navigate(`${checkoutURL}/${token}/create`);
  };

  // const popoverTargetID = 'share-preview-button'; (ENGA-1367)

  return (
    <>
      <main id="skip-link-target">
        <div className="row no-print">
          <div className="columns">
            <IntroSection title="Review Press Release">
              <SubHeader as="div" subHeaderClassName="subheader-text-v2">
                Edit or delete press release at any time once published.
              </SubHeader>
              <nav className="review-navigation-v2 button-container">
                <button type="button" onClick={handleBackNavigation} className="button button--soft">
                  <span>Return and edit</span>
                </button>
                <button type="button" onClick={window.print} className="button button--soft">
                  <span>Print</span>
                </button>
                {/* // PRESS RELEASE PREVIEW HAS BEEN DISABLE AND WILL LIKELY BE REMOVED (ENGA-1367)
                  <button type="button" id={popoverTargetID} className="button button--soft review-navigation-v2__button">
                    <Eye />
                    <span>Share preview link</span>
                  </button>
                  <SharePreviewPopover pressReleasePreviewUrl={pressRelease.preview_url} popoverTargetID={popoverTargetID} />
                */}
                {pressRelease?.status !== PRESS_RELEASE_STATUS.PAID && (
                  <button type="submit" onClick={handlePromoteClick} className="button button--medium">
                    Continue to checkout
                  </button>
                )}
              </nav>
            </IntroSection>
          </div>
        </div>
        <PressReleaseWrittenContentV2 pressRelease={pressRelease} cloudinaryCloudName={pressReleaseMetadata.cloudinary_cloud_name} />
      </main>
    </>
  );
};

export default ReviewScreen;
